(function(app) {

    app.directive("alertTheme",
        function($mdTheming) {
            return {
                restrict: "e",
                link: function(scope, el) {
                    $mdTheming(el);

                    $mdTheming.defineTheme("alertTheme",
                        {
                        });
                }
            }
        });

    app.directive("confirmDelete",
        function ($mdTheming) {
            return {
                restrict: "e",
                link: function (scope, el) {
                    $mdTheming(el);

                    $mdTheming.defineTheme("confirmDelete",
                        {
                        });
                }
            }
        });

    app.config([
        "$mdThemingProvider", function($mdThemingProvider) {
            $mdThemingProvider.theme("alertTheme");
            $mdThemingProvider.theme("confirmDelete");
        }
    ]);

})(window.app); //jshint ignore:line